// Transactional mail (DESK-OPERATOR-AND-MAIL-BRIEF §3, ADR-0027): the platform
// sends its own mail — the booking confirmation first. A platform concern by
// the same test as the desk operator: any context may need to mail a guest,
// none may pick its own provider. Pure — the port and its result; the Brevo
// adapter is at `@lemontaigu/platform/adapters/edge` (a Function holds the key).

export interface TransactionalMail {
  to: string;
  toName?: string | null;
  subject: string;
  /** Plain text, always: what every client can show. */
  text: string;
  /** Optional HTML alternative. */
  html?: string | null;
}

export type MailSendResult =
  | { ok: true; providerId: string }
  /** `retryable`: worth sending again later (rate limit, provider down); not
   *  for a refused address or a bad key, which a retry cannot fix. */
  | { ok: false; reason: string; retryable: boolean };

/** The driven port: one mail, sent now. */
export interface MailSender {
  send(mail: TransactionalMail): Promise<MailSendResult>;
}

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const mailAddressOk = (e: string): boolean => EMAIL.test(e.trim());

/** The placeholder the desk's text carries where the card link goes (D6). */
export const CARD_LINK_PLACEHOLDER = '{{lienCarte}}';

/** A queued mail, claimed for sending (`mail_outbox_claim`): the link is in. */
export type MailClaim =
  | { ok: true; to: string; subject: string; body: string }
  | { ok: false; reason: 'refused' | 'notFound' | 'notReady' | 'unavailable'; status?: string };

/** The sender Function's side of the outbox — service role only. */
export interface MailOutboxSender {
  /** For the caller the Function verified: their capabilities and reach decide. */
  claim(outboxId: string, authUserId: string): Promise<MailClaim>;
  record(outboxId: string, result: MailSendResult): Promise<void>;
}
